import { vueAppWithStore } from "../Common/vueApp";
import NotificationCenterListingApp from "./NotificationCenterListingApp.vue";
import Vuex from "vuex";
import { promiseRequestFactory, requestMutations, requestState } from "../Common/Vuex/request";
import notificationsCenter from "../Api/notificationsCenter";

const store = new Vuex.Store({
    modules: {
        main: {
            namespaced: true,
            state: {
                ...requestState,

                notificationOrders: [],
            },
            mutations: {
                ...requestMutations,
                setNotificationOrders(state, payload) {
                    state.notificationOrders = payload;
                },
            },
            actions: {
                refreshNotificationOrders(context) {
                    return notificationsCenter
                        .init(promiseRequestFactory(context))
                        .getNotificationOrdersListing()
                        .then(orders => {
                            context.commit("setNotificationOrders", orders);
                        });
                },
            },
        },
    },
});

export default vueAppWithStore(NotificationCenterListingApp, store);
